import { populate } from 'populate'; import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'WorldLayout22',
  width: 0,
  height: 0,
  x: 50,
  y: 100,
  list: [
    {
      id: '1',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '2',
      type: 'Container',
      name: 'backgrounds',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '3',
      type: 'Container',
      name: 'nodesContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '4',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '5',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'world22_1',
      parent: '2',
      data: ''
    },
    {
      id: '7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1352,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'world22_2',
      parent: '2',
      data: ''
    },
    {
      id: '8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2704,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'world22_3',
      parent: '2',
      data: ''
    },
    {
      id: '10',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5408,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'world22_5',
      parent: '2',
      data: ''
    },
    {
      id: '9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4056,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'world22_4',
      parent: '2',
      data: ''
    },
    {
      id: '11',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6760,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'world22_6',
      parent: '2',
      data: ''
    },
    {
      id: '12',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8112,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'world22_7',
      parent: '2',
      data: ''
    },
    {
      id: '13',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9464,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'world22_8',
      parent: '2',
      data: ''
    },
    {
      id: '56df0195-6463-44b9-940d-5d3496e6e0cd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 329,
      y: 485,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'baa6dd6b-b5e8-419d-9892-6c637c0781b0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 395,
      y: 541,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3bb8cfad-ec70-4025-86d5-ca682c108d7b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 488,
      y: 545,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a9b7b0af-0ad0-473a-84a9-c7d83c80e392',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 578,
      y: 518,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7606d46f-35a0-480b-8a6c-36fa1887dce8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 653,
      y: 469,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f0a79483-7ecc-4e50-b832-d0a0025593c4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 717,
      y: 407,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f4b02f23-91f8-4dcb-b687-ed7574eb01a7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 782,
      y: 350,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b735ebbf-1fad-4dc6-b190-634aa204a8c8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 867,
      y: 316,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '804c69f6-58ba-411d-a648-1b3dd2694ba9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 941,
      y: 364,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f73ed37a-dbb7-4fcd-b880-be63fc93e033',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1007,
      y: 423,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '39bfe8e7-d9df-44f6-b9b6-370b4562cd75',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1075,
      y: 479,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'abfd17fb-6549-4f3f-812d-8a528aa637c9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1163,
      y: 501,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '58ca9774-f966-4a22-a0df-a7c67fad732e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1238,
      y: 451,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd7617b08-e6cf-428c-ac2f-0b73664ddede',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1289,
      y: 381,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1e4333a0-7c12-4c06-a9a5-c80eb6f5a288',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1348,
      y: 316,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f56d5a57-eae7-4f58-a902-11da50ff0c58',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1416,
      y: 261,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'adaae98e-2a1c-4b25-9ae6-1f7afcf853ed',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1507,
      y: 246,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd799cf3b-c4c1-44db-a19b-6b17f4c3c7fe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1600,
      y: 250,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ae93e548-c3f2-4d7c-8c0a-6f3a647269f2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1687,
      y: 280,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '22b78189-cce5-4773-abce-35678af87030',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1770,
      y: 317,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e8ebaf02-a4b1-46eb-8970-1dbbbae21913',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1848,
      y: 362,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '822dd6cf-9342-486f-91c4-6193aca2b6eb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1932,
      y: 395,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '49c06ff0-eee6-476a-8f43-c3fb6e985e81',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2026,
      y: 401,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ff8b1daa-6364-4bc0-b360-1528c461031c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2119,
      y: 391,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e8dd721f-3892-460f-beb5-3e2d021ce604',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2208,
      y: 362,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5e91d8d0-db82-41d0-95af-edecbd47f3ff',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2284,
      y: 315,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '9215fe8e-a32e-4c76-a01d-5e6c034809a6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2369,
      y: 278,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '62cd1e22-df51-4948-a8fe-4531405b240a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2460,
      y: 253,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'acc92759-7616-4df6-88fa-ba84aaf075b9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2554,
      y: 254,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e1229ffd-eae4-4f08-9c32-e4f4672f3358',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2644,
      y: 278,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5f803198-f2f7-4f7c-ad38-a940279ef4ba',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2727,
      y: 318,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '75071521-b99d-4bd9-9e75-ea80231e6def',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2817,
      y: 347,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '643a8f68-84df-4137-9228-5cdc32830f80',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2912,
      y: 360,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '22070386-71e8-46b3-aae2-1dc54c1a2391',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3006,
      y: 356,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'bdcf620e-8ffe-41c1-bfe0-ad19ac39c54f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3098,
      y: 336,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2edffa4e-a98f-4343-96a1-749c4b0c6b4a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3183,
      y: 300,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'bd33a4e1-525a-46c3-869c-e38b80f1b4e0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3273,
      y: 270,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'cff72ebe-b1c3-471a-929c-25394458eca8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3369,
      y: 264,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'fe04656a-d5ff-4003-b97d-97d232ef6210',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3462,
      y: 284,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a573eb65-2f0b-423e-9f0c-bc8bbe831edc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3555,
      y: 304,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '74bcd6f4-f684-4430-b568-6ac7e4ba776e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3644,
      y: 335,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '58d318d6-2629-439f-af2e-7c57f07327a2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3725,
      y: 381,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '0be68335-ca54-403d-9b02-3e865f7ab83c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3798,
      y: 436,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '595507a8-341a-4456-8bf5-3b09f51aff23',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3878,
      y: 484,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6c0229e1-edae-4ad3-8820-acf8d3e748b7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3974,
      y: 509,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c6385708-dd4c-458a-ac35-9c1065605eb1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4078,
      y: 507,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '232eb68d-6df9-4b56-9e6b-c7c4e6cc27ae',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4173,
      y: 477,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c800e4cb-06d8-483e-b1e8-8ea14771dd9c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4259,
      y: 429,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'eed77189-a4c6-43b2-ac21-00dc888a20c1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4348,
      y: 382,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '89b9621c-f9d6-4052-ad39-789f02ed34d6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4429,
      y: 331,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'fca78ece-99fd-42b3-8fe6-a91b6b9d61c2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4529,
      y: 312,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '04b3f16b-648a-487f-b1ae-e7a2a43b2789',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4629,
      y: 319,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b31d1ea2-6cab-4b3d-acc9-564afcda2d94',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4718,
      y: 356,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4f380e59-aa2c-4185-bba9-2859219efd1f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4803,
      y: 402,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '487ee5ae-816e-4451-ad7d-2983a4118064',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4887,
      y: 447,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e534b071-4f7c-4e7d-ae21-4718fefc844b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4984,
      y: 471,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '28d9cf5e-3d7d-4d69-aa89-724a6b548d30',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5085,
      y: 475,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '28500dda-2f8a-4c6a-a895-6a3d58f19a11',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5185,
      y: 470,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '9719f0bb-f750-4ba7-b996-6d09f53e12c1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5267,
      y: 418,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '57e93ecb-8131-4445-adcc-20f0453f4ab1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5316,
      y: 337,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6939a97b-754e-4a1b-bf8e-091395599f77',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5407,
      y: 296,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'eab2eb23-e88c-4b59-b194-2a6542faeaf8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5505,
      y: 312,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '8188c6a1-f8db-4c12-a27a-f108fecae9a0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5601,
      y: 328,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3a167c19-cc96-482d-b469-27dc8c63d2dd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5691,
      y: 365,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '9668fb21-5c5c-4097-8e92-d6cae03d3219',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5773,
      y: 415,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '61614812-67c6-4eb0-88ad-5c3c8e0c05af',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5861,
      y: 455,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3d4303a0-fa13-4d72-a61b-17a5e4a8c0d5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5952,
      y: 488,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b985ea51-be51-4a5f-aca7-463e3d2b63f1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6050,
      y: 505,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b916cf8e-e8da-4405-b63d-5a84b588c464',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6150,
      y: 516,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '77e4c7ae-2433-495b-8604-bdc804e6531d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6245,
      y: 486,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ca07827e-bfc2-4982-a3cf-07f80cf6bf52',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6322,
      y: 428,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c0eea450-daa8-40ce-b1ea-29f99400a629',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6403,
      y: 377,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7190020e-aa01-48b0-ba2f-2fbc993f41ea',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6491,
      y: 333,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e5c067c2-445e-4175-9c6b-5f3eb385f4f5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6591,
      y: 317,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'fe721e71-77f6-4afc-ad4b-5afcb9381fb8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6684,
      y: 349,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '54688294-d03a-4d26-a3eb-9c108bd2ec00',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6774,
      y: 390,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '8848530e-43c0-4b18-8615-bc68824a7237',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6861,
      y: 435,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'db03ab93-8dc3-4c3d-bf37-746e23016df6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6954,
      y: 469,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b15456bd-a71c-4828-a7e7-46e22d86a46d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7053,
      y: 476,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a396f8cb-34ca-40eb-a835-0f8df7a40cb1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7152,
      y: 462,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ef4ac57b-aca6-4b27-92b9-6a517bd8507e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7248,
      y: 438,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3c454d18-a30f-427f-803a-7142bf7df7a3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7340,
      y: 403,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'bbf3a950-60c5-4e3b-b5a0-3ec0cb42bddc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7432,
      y: 367,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e075fd2b-5d08-4908-a4a1-07a86ba483e7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7518,
      y: 319,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd6a9f4ea-1c7e-4893-a4f7-3eb6a309b2a3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7615,
      y: 302,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f1fb5e4f-a85d-4826-9426-1ebf8959de36',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7712,
      y: 319,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'aab52b80-7c80-4013-a65a-e4c07068595a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7805,
      y: 354,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b8b0216f-1ec8-4214-ac4e-713be5025ada',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7884,
      y: 407,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd1e22816-6e57-448e-944c-90b0d426d272',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7962,
      y: 457,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2710cef7-6baa-4330-8590-587a6af74ca7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8048,
      y: 495,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '8611737d-f6db-460c-8065-3d95a90e24a1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8144,
      y: 507,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '189adbd5-21fc-4cb6-862a-126f376a92a9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8240,
      y: 516,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'cf4de5ad-f3fe-478c-9417-5f1f99643fef',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8336,
      y: 520,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3a80dc96-8099-4838-8fd0-ede6d10e8002',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8432,
      y: 534,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b61575c2-a9ae-407a-baa9-69e171fc55c5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8529,
      y: 532,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '37d5f66c-94d3-49cd-b581-f9b0f01a2216',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8625,
      y: 512,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4be31249-20d1-4af1-8736-a0ad9d50af3d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8714,
      y: 475,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4f14bb01-54e6-4463-b2d5-02bbe1a01222',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8794,
      y: 433,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '652a8d11-7e84-44a4-86fd-4240437abc5c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8871,
      y: 388,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c97e5ddc-b0bd-4078-b308-c4a436983e33',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8959,
      y: 356,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '868d5dac-5b18-4f67-add7-5e5bb8372b2c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9050,
      y: 375,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4c93a120-c171-4506-9b35-757358ead3a4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9137,
      y: 409,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4b5c07f3-ada1-4f88-80a4-5e43b5d7878a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9223,
      y: 439,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b33869e2-84e3-4706-bfc9-8d819474bd10',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9310,
      y: 463,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '34d4dbf3-00d5-49ab-8f19-1ab47b6813a3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9395,
      y: 428,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '412a054c-eadc-40d2-a203-17397e41107c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9457,
      y: 367,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '635cc6a4-3a75-4266-986a-d494d1dad213',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9511,
      y: 301,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '9cb20854-ab1d-4148-a675-3a9b9dd32c41',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9561,
      y: 231,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '54047c9b-30bf-4a2f-bbf4-81906eb2781f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9646,
      y: 197,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4c271313-0404-47ef-8eba-3460b77d98cf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9736,
      y: 220,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1e68e754-d2a9-46d9-aa0d-a9f8e9bd6227',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9797,
      y: 281,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd044bdb3-fcf9-4705-98e2-1dce596ce355',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9846,
      y: 349,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '68720e29-d996-406d-90e0-d780a2b4ef33',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9882,
      y: 426,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '52ed64db-34df-4f5b-ab80-551882541361',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9931,
      y: 495,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd0fa01cc-5cf3-46eb-b95f-7e3bb3dcd908',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10022,
      y: 508,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7de7536f-422b-4693-a9d5-57ac6a3120ba',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10116,
      y: 501,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '533289df-9f86-4845-b8f1-b58cb2b544ca',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10201,
      y: 463,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '27e373ec-a5ef-4047-aaac-df4ab55a4355',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10277,
      y: 415,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '049b6f76-bef6-42d6-8a2e-ed08e3178be9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10351,
      y: 368,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b0feef65-7370-40b4-b644-4caadf5d0c22',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10443,
      y: 365,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '74',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '110',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '164',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '185',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '214',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '219',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '224',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '1b355a2e-d409-489c-8af4-a150c082b42b',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '106',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '160',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '181',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '210',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '215',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '220',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '225',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '230',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: 'dd3fa40e-657a-4283-81e6-34886e46872a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1390,
      y: 74,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: 'fabbccf3-a852-4611-8c53-eb9814ef3a51',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1262,
      y: 35,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: '6bab173e-0dc2-4bbb-9ea7-c27d7eb0f2de',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1252,
      y: 125,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: '1b55637f-0942-4b03-82de-e880ebad6f1e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1365,
      y: 157,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: 'fce154f6-1767-4f16-8846-ea78b479ac6f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1138,
      y: 85,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: 'fb40cb86-177e-4525-a1a6-1cdb6e404e1f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1170,
      y: 202,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: 'dc27277c-4245-49b5-925b-8c13fac82a21',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1062,
      y: 159,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: '10328b44-36d0-4517-8afe-4699ee17fc23',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1074,
      y: 244,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: '37d33cab-3666-431c-bc63-58be7773611a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1155,
      y: 301,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: '726705d3-160b-4570-824e-27af160498fc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 853,
      y: 568,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: '98b3d19a-aa78-42b0-833c-7a32811f3b22',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 957,
      y: 624,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: '5f14391c-c6d5-4d4b-94e8-0162c623e1cf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1018,
      y: 700,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: 'bb2c3999-be59-4d0f-8195-330d2d05de75',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 759,
      y: 630,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: '81c0ad39-754c-4a32-a42c-c5ac9e9938e2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 859,
      y: 684,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: '4e17c9f7-7ec8-4435-8013-5e072bd16ddb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 907,
      y: 772,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: '380848ca-5a9b-4d12-a044-bce9669670f9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 715,
      y: 721,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: '9bbf7133-2971-40d6-989c-b1eea9d69c69',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 605,
      y: 768,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: 'b92fbc64-0e6e-426b-8a3b-d322ad2200c8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 777,
      y: 801,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: '8ab1da81-71f5-4217-abf9-835630867ecf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1267,
      y: 219,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '74',
      data: ''
    },
    {
      id: '7f0e89f6-8dba-4bb7-980c-54c63f144d63',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1564,
      y: 468,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '1ad1d54e-54fa-4d15-a368-0bde269d922c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1688,
      y: 513,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: 'b495c43e-862f-4bc9-889f-0df52340b359',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1902,
      y: 45,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: 'ca5db20b-6fae-41a5-bbe7-9103b2a4a5c8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2072,
      y: 37,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '14f16757-345d-47a1-b6aa-e62706339df6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2072,
      y: 37,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '72639321-fb9f-46b1-8724-18a4f1a8f855',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2236,
      y: 45,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '20e1030d-c889-47ab-bce3-66153675228e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2405,
      y: 36,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '20a73c5a-590f-4ecd-b9a9-75356a19f9ae',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2456,
      y: 473,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '383485ca-19db-4eb9-ad09-a63795698e83',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2563,
      y: 542,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '573d7b52-8eb1-45ad-8737-8c62d5138ecc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2636,
      y: 644,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '8435e376-c0c7-46b9-9055-d03a51b526fc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2636,
      y: 644,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '1ee9ac14-68a7-496c-a6e0-af657f51df76',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2520,
      y: 709,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '418a19b8-f37f-4e9e-8166-b54c9f54a015',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2398,
      y: 769,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '3921761a-e9ff-4529-a683-e8227378bdae',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2341,
      y: 547,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '204db6f8-d53f-4c94-a3c1-6017c8e0541a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2450,
      y: 610,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '88417891-be54-4ea3-b77e-b513317f659c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2228,
      y: 620,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: 'ee43ccea-e051-431b-9c8a-946df47f2356',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2340,
      y: 673,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: 'bb25ada8-8364-44ef-9725-5abdc3ea588d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1786,
      y: 120,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: 'ade431ad-081b-4564-86c7-506143791cfc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1972,
      y: 123,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '7e50c49a-1fa2-476b-9f24-eb7f40e9ecf0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2149,
      y: 115,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: 'eb85bb2b-b379-4173-8eb9-fbda11ba13ad',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2319,
      y: 116,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '985176b5-570e-49e9-a714-c760a5cbbb66',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1869,
      y: 193,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '0cdac48f-1f69-47d8-a6b1-7208799e55bb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2064,
      y: 184,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '019452f7-244d-409e-9572-6735c2a5ded0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2231,
      y: 190,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '8867cead-e089-4133-85c0-73b4b763ffbb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1993,
      y: 267,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: 'a6dc192f-784c-4b4c-bfa3-47f27fce1fb8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2133,
      y: 252,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '9d95a1bb-2de5-4e5d-978a-5de44d1dae79',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1809,
      y: 566,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '59e0faae-7d6d-4707-9bee-b825e2ca5544',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1915,
      y: 630,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: 'b57cbc18-1fa8-4a81-b2fa-e5c3a56042a0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1738,
      y: 646,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '85b535c5-e877-4ec4-8ecb-0667e45f80aa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1476,
      y: 546,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '8d2e2ee1-7469-4bd8-aded-58a1c77b7f34',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1608,
      y: 577,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: 'bc1b0f41-51bb-464e-97d1-b8b63bb2989f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1422,
      y: 648,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '69a909e7-90c6-4127-9239-514c63286fba',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1569,
      y: 682,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '9a8b7f4f-3131-4eb2-adf1-7c6b7b016b01',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1859,
      y: 722,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '57134b53-9fe8-4e67-a4b4-c72fbfa8604b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1723,
      y: 752,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: '692f0e81-999e-4f21-8bd6-6fef900769ae',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1407,
      y: 744,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: 'eb413db9-ce2f-49a4-8d58-2e163af90ea0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1567,
      y: 784,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_4',
      parent: '110',
      data: ''
    },
    {
      id: 'c230c23a-49a9-4baa-8080-0910942414ee',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3057,
      y: 133,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '164',
      data: ''
    },
    {
      id: 'b31bf502-53b8-47de-890f-89ae4821d5dc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3171,
      y: 229,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '164',
      data: ''
    },
    {
      id: 'ad36569d-4b8b-4b68-8ce9-cb5412f7e4d5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3260,
      y: 545,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '164',
      data: ''
    },
    {
      id: '1ef219d2-7151-43dd-987f-980d768f0df0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3487,
      y: 572,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '164',
      data: ''
    },
    {
      id: '123c71e6-8d15-4c1a-a798-a5b00f6a633c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3307,
      y: 745,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '164',
      data: ''
    },
    {
      id: 'ff3508e1-57dc-4e9b-99c3-aee20f9d83fe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3082,
      y: 711,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '164',
      data: ''
    },
    {
      id: '9fb392a9-52a7-4129-858b-a2f1705dbe2f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3891,
      y: 779,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '164',
      data: ''
    },
    {
      id: 'bf3f4c39-139a-4c12-bb92-758584f2ec52',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3555,
      y: 787,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '164',
      data: ''
    },
    {
      id: 'a63f316a-29e8-4fc7-a339-bde4636dd296',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2840,
      y: 745,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '164',
      data: ''
    },
    {
      id: 'e4ea77be-ce07-40a5-afcc-58e6bddaec62',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3726,
      y: 673,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '164',
      data: ''
    },
    {
      id: 'ca26b320-24b1-4a51-9754-c0b723af6486',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2946,
      y: 276,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '164',
      data: ''
    },
    {
      id: '26a899a8-2dc7-4a4b-895a-c0863d066d9f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4159,
      y: 176,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '185',
      data: ''
    },
    {
      id: '8f63a2f4-08e8-43a9-b9f8-5397255c63c2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4369,
      y: 148,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '185',
      data: ''
    },
    {
      id: '7ccb0587-8be1-40f1-a038-d3c930daddcd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4497,
      y: 201,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '185',
      data: ''
    },
    {
      id: '35372076-ad86-4558-8afa-f44a98edd3a8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3980,
      y: 72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '185',
      data: ''
    },
    {
      id: 'f3e25f9a-0553-4ae7-b95a-5ae0ea25d894',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3892,
      y: 220,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '185',
      data: ''
    },
    {
      id: 'f9963fa7-ff7a-408f-9d3a-9d2f7a1fd2bd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4062,
      y: 316,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '185',
      data: ''
    },
    {
      id: '13b7877c-04d3-4a6d-a703-5266d40af81a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4303,
      y: 305,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '185',
      data: ''
    },
    {
      id: '88c22689-6641-4046-8252-8b72224a5e1d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5036,
      y: 738,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '185',
      data: ''
    },
    {
      id: 'df6d980a-96fe-4c64-9998-269af4a71765',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5157,
      y: 134,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '185',
      data: ''
    },
    {
      id: '8da12424-066e-4ea5-b6da-da1dc3c5f4a6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5306,
      y: 182,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '185',
      data: ''
    },
    {
      id: '12265233-c40e-4b1a-a606-bee6344471df',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4987,
      y: 192,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '185',
      data: ''
    },
    {
      id: '588ea032-d019-45f9-9b70-cefb296de5a7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4820,
      y: 283,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '185',
      data: ''
    },
    {
      id: 'b6e69680-cd0f-43f6-ab1a-2eed9e9737ad',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4985,
      y: 377,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '185',
      data: ''
    },
    {
      id: '42c47e5d-5f17-44a1-b512-5b1e9ee485d1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5152,
      y: 354,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_4',
      parent: '185',
      data: ''
    },
    {
      id: 'c7cf4b19-8c0b-4762-bfdd-0c35295a8517',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5794,
      y: 39,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '7a49ec7a-3d16-40af-8dd0-5766e3efa2c5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5927,
      y: 33,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '942b4fdc-1491-4b32-b289-b6b2f2896a8e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6061,
      y: 32,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: 'fc61123d-b0be-436e-866b-ae0904774e01',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6199,
      y: 22,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: 'c8549d5b-d252-4e46-87bd-580f45d1238f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5866,
      y: 147,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '7aba00bb-c949-4694-a1a1-cb40736d4d12',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6011,
      y: 156,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '0e719fb8-f333-4194-baf7-fccf9b08fc54',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6163,
      y: 158,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: 'f2912154-d6a9-4d55-b954-bd5ed84ed1c5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5745,
      y: 190,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '34613589-1841-4636-b346-5cdecb580903',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5947,
      y: 262,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: 'c9913dbc-c433-4153-9303-b869babccfda',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6104,
      y: 268,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: 'f3653201-e9d1-417b-9b59-f37ed965cf79',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6269,
      y: 266,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '80c180dc-7d1e-49f1-9c26-8725055c9e30',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5815,
      y: 306,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '337f1845-9a5d-4516-b2aa-3e380d83e58c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6006,
      y: 387,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '4c18168d-ea57-42bc-8731-db7e6726c2f7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6199,
      y: 363,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '714a9446-fa55-477e-8210-e83f086b5c2c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5530,
      y: 575,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: 'c2fcfaa8-4641-4980-b0ad-950df8389649',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5691,
      y: 585,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '6338d011-71ea-427b-acf9-999ed6ae01f8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5840,
      y: 668,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: 'd76cc955-c75d-43c7-8283-0204abb39a8e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6006,
      y: 719,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '55369ea5-43f3-450d-8d05-8d3045b88b05',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5607,
      y: 691,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '36bf76d7-b1f8-4937-a343-756198599896',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5744,
      y: 741,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '04e33ce7-1bac-478c-beef-a29d1f8fef1a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5917,
      y: 826,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '243f9199-f388-49df-98c9-45196e8f2ede',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6129,
      y: 858,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: 'ad6408f9-a5ed-4ffe-a35a-cea25b9de0fe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6615,
      y: 516,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '145a1bfb-0fad-4b98-829f-d09872aa6593',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6482,
      y: 563,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: 'ea2cb5d7-ef22-4fd2-a681-8e0c0ba33b38',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6368,
      y: 632,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '9aa01f39-3fb3-4717-9a2d-8952b9f77838',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6745,
      y: 588,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '046cd56e-f929-45ae-bf21-2bc170b7436c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6873,
      y: 687,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '917079af-0e15-4bee-a388-34645f8158c2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7008,
      y: 786,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '1c97cb32-4b94-43b7-ba9c-275b8c9925c9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6601,
      y: 645,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: 'a71b3958-a8c5-4889-930b-a4cd9bdb3fb7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6734,
      y: 725,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: 'dfe5e904-a38a-4bfc-bccf-3e088ecf15ca',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6866,
      y: 849,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '19ce0545-60a9-41ff-9576-4681c94a60f6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6628,
      y: 827,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: 'b425ec02-4ab7-4c0b-8366-29495533ad42',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6474,
      y: 729,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: 'c06883a4-f246-48e3-baca-339f2805223e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5692,
      y: 864,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '214',
      data: ''
    },
    {
      id: '9068c0ee-d8c2-4a28-bb42-757c4c3798fd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7789,
      y: 33,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: '57ce1949-3d5e-4799-8657-d41826335dd8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7944,
      y: 31,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: 'f632e499-1eda-4221-a06f-902bbd492d77',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8038,
      y: 127,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: '058f7bfe-9734-42c7-b67c-72732a819ab2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7878,
      y: 131,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: '7973ec9f-9570-44cb-90d1-fd0ef5fcd790',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7623,
      y: 43,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: '01b04f5b-87bd-43d7-a61c-e5514c738468',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7724,
      y: 126,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: '289774b9-710c-4ea0-8bca-0969c404b153',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7590,
      y: 140,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: '55ff8c92-a7b4-4f6a-b5bf-b6fb3c7595f9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7950,
      y: 257,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: '7e8deb2f-f67f-40ee-acb1-13dc549bf12d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7605,
      y: 492,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: '4facd393-4f56-47d1-a7ba-3f287ab7db7b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7746,
      y: 532,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: '6434d9f9-147d-4cf2-b221-c4810939b17f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7860,
      y: 593,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: '5ee851fc-85f4-4a48-80ad-f67feabc329c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7606,
      y: 614,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: 'da6bcd68-da28-45aa-bffd-56adb66178c5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7750,
      y: 675,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: 'acfd08bd-e5d0-44fa-9d59-55c98f63c672',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7467,
      y: 559,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: '4b7233e9-23a0-4003-9f27-20a6bc0fb124',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7337,
      y: 639,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: 'c00f85e3-9920-4bde-a0be-5488de5dfc05',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7469,
      y: 684,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: 'b13b88ea-0f2f-4b11-9684-1022704cd041',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7605,
      y: 742,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: '43c33daf-f2eb-41a7-80c1-42db059c3bce',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7779,
      y: 815,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: '2cbee25b-46b9-45b7-a145-97738c871351',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7883,
      y: 704,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: 'db57f886-7d6e-4a01-bd5f-20268039cfa8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7377,
      y: 787,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: '53e785c2-501c-459e-a502-6480c522be1e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7522,
      y: 859,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: 'ac11857c-9dc0-4dcb-8e96-5fa129bfb4ca',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7810,
      y: 237,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: '5ce73adb-8f54-45c6-8088-cb0c30c76917',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7664,
      y: 220,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_4',
      parent: '219',
      data: ''
    },
    {
      id: 'bb88d2cc-bab9-4bc6-808f-476ebcde73bf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8297,
      y: 270,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '224',
      data: ''
    },
    {
      id: 'c4bacf15-b409-43db-81ec-51a80886285a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8575,
      y: 249,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '224',
      data: ''
    },
    {
      id: '8ae6871b-7d08-490b-9246-90295c063d05',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8755,
      y: 154,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '224',
      data: ''
    },
    {
      id: '8e16c505-dddf-413e-b985-169966105d23',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8156,
      y: 409,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '224',
      data: ''
    },
    {
      id: '1316154e-d35d-4f72-9390-214aa8519c38',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8411,
      y: 434,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '224',
      data: ''
    },
    {
      id: 'dfd1722a-d1b2-4381-a99d-95ae8bfa0d1a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8620,
      y: 419,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '224',
      data: ''
    },
    {
      id: '53ea8586-9359-469c-8bdb-892cfca5d12c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8813,
      y: 308,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '224',
      data: ''
    },
    {
      id: 'c6bd2efa-b03b-4b67-b546-d68756a4ba80',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8827,
      y: 713,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '224',
      data: ''
    },
    {
      id: '2f380ade-23f7-4c0c-b7ad-99a33952e49f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9274,
      y: 127,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '224',
      data: ''
    },
    {
      id: '1db324f6-8c92-4e81-aace-2c90d276a370',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9049,
      y: 673,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '224',
      data: ''
    },
    {
      id: '301d129d-9303-4a0e-a93c-dca2b3e69fa9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9432,
      y: 234,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '224',
      data: ''
    },
    {
      id: 'a980a0d7-d7a8-471f-ba25-b10add9bee5b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9158,
      y: 275,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '224',
      data: ''
    },
    {
      id: 'd9094a7b-297f-4cf7-8ee1-afadd52237ec',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9316,
      y: 375,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '224',
      data: ''
    },
    {
      id: '043903ca-290a-40ac-a6ca-45e6d4bac730',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8457,
      y: 173,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '224',
      data: ''
    },
    {
      id: '02ff52c2-aa97-49bd-8a79-a20e9e60c234',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9682,
      y: 114,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'b09e193a-ffb3-4f11-b20b-089b5ba025a0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9879,
      y: 160,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '5b328a51-8ae2-40db-abcf-2fd9e0f15f61',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10070,
      y: 282,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '40e10f75-7bd2-49c0-9322-2044847b4ab8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9998,
      y: 408,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '921d6566-0418-4c93-a4a6-471488c3ecd5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9668,
      y: 598,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'd6d63f50-4e7b-4908-95d2-d1291770153f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9832,
      y: 726,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '18c98ed3-97bc-490c-8df0-ab1fb689134d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9464,
      y: 673,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1145,
      y: 210,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '106',
      data: ''
    },
    {
      id: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2242,
      y: 552,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '160',
      data: ''
    },
    {
      id: '15ecb407-34dd-49fd-94d1-15dd5136e53f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3397,
      y: 538,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '181',
      data: ''
    },
    {
      id: '44e93875-1962-4c55-ba54-c3293bb0e9ea',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5070,
      y: 287,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '210',
      data: ''
    },
    {
      id: '107',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6092,
      y: 292,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '215',
      data: ''
    },
    {
      id: 'f91af2df-8d3d-49a3-8040-33bebb847e55',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7618,
      y: 543,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '220',
      data: ''
    },
    {
      id: 'e5a00353-b3ea-4436-b6f7-619f1dcc42d9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9227,
      y: 272,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '225',
      data: ''
    },
    {
      id: '4f3d25a5-5ef3-4047-a7ae-61f2040e854e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10095,
      y: 307,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '230',
      data: ''
    },
    {
      id: 'e9b75b1f-8160-4ef5-b5b9-9efa162189aa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      data: ''
    },
    {
      id: '85746295-e987-4e2b-a7d0-6791216b55a9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_harvest_map',
      parent: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      data: ''
    },
    {
      id: '8760c148-9cef-4f28-9a17-22e855cf0c84',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      data: ''
    },
    {
      id: '656a5808-34d6-4751-a733-6af98d163ac6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'broccoli_harvest_map',
      parent: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      data: ''
    },
    {
      id: 'c001f4bb-2f73-4bf8-8953-deb543c31f21',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '15ecb407-34dd-49fd-94d1-15dd5136e53f',
      data: ''
    },
    {
      id: 'c41c933b-373f-4a3d-bdc7-f748ce87c274',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_harvest_map',
      parent: '15ecb407-34dd-49fd-94d1-15dd5136e53f',
      data: ''
    },
    {
      id: '16ac1fb4-d061-449e-87ad-02f0d5dff6e9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '44e93875-1962-4c55-ba54-c3293bb0e9ea',
      data: ''
    },
    {
      id: '958851db-006d-425c-afff-a85018a3cb2b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'apricot_harvest_map',
      parent: '44e93875-1962-4c55-ba54-c3293bb0e9ea',
      data: ''
    },
    {
      id: '108',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '107',
      data: ''
    },
    {
      id: '109',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_harvest_map',
      parent: '107',
      data: ''
    },
    {
      id: '46aeb65d-4896-4557-9865-75ef0057e163',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: 'f91af2df-8d3d-49a3-8040-33bebb847e55',
      data: ''
    },
    {
      id: 'ac0db26e-8010-4059-87b0-18b44d3c25ca',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'beans_harvest_map',
      parent: 'f91af2df-8d3d-49a3-8040-33bebb847e55',
      data: ''
    },
    {
      id: '03074616-c479-4d19-9e8c-855582627513',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: 'e5a00353-b3ea-4436-b6f7-619f1dcc42d9',
      data: ''
    },
    {
      id: '018bb44b-6ca0-491c-b479-368ca2fa6897',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_harvest_map',
      parent: 'e5a00353-b3ea-4436-b6f7-619f1dcc42d9',
      data: ''
    },
    {
      id: '2e08b7f7-57a1-4e7c-baf5-459d9f88afdd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '4f3d25a5-5ef3-4047-a7ae-61f2040e854e',
      data: ''
    },
    {
      id: 'c077834a-7855-43ec-a465-2f5ed5df5421',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'chestnut_harvest_map',
      parent: '4f3d25a5-5ef3-4047-a7ae-61f2040e854e',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class WorldLayout22 {
  static raw = raw;
  root: PIXI.Container
  backgrounds: PIXI.Container
  nodesContainer: PIXI.Container
  cropsSectorA: (PIXI.Container)[]
  cropsSectorB: (PIXI.Container)[]
  signsSectorA: (PIXI.Container)[]
  signsSectorB: (PIXI.Container)[]

  constructor() {
    populate(this, raw);
  }
}
